module.exports = __webpack_public_path__ + "img/128.64813075.png";